import React, { Component } from 'react';
import Chart from './chart';
import EducatrosAPI from "../api/educatorAPI";
import Progress from "../CircleProgress/index";
import {actions, SelectField} from "react-fields";
import PeriodSelector from '../base/periodsSelector';

class Result extends Component {

    state = {
        data: null,
        stats: {},
        chart_period: '30_days'
    };

    componentDidMount() {
        this.loadChartData('30_days');
    };

    loadChartData = (period) => {
        EducatrosAPI.getTestsStats(period).then((response) => {
            this.setState({data: response.graph, stats: response.test_stats})
        }).catch(error => {
            console.log(error);
        });
    };

    onChangeField = (e) => {
        this.setState({[e.target.name]: e.target.value}, () => {
            this.loadChartData(this.state.chart_period);
        });
    };

    render() {
        return (
            <React.Fragment>
                <div className={'flex-grid__container'}>
                    <div className={'flex-grid__item flex-grid__item--grow'}>
                        <h3 className="h3--big">Test stats</h3>
                    </div>
                    <div className={'flex-grid__item flex-grid__item--shrink'}>
                        <PeriodSelector name={'chart_period'} value={this.state.chart_period} onChange=
                            {this.onChangeField} hideAllTimeFilter={this.props.hideAllTimeFilter} />
                    </div>
                </div>

                <div className={'grid-x grid-padding-x'}>
                    <div className={'cell large-8'}>
                        <div className="text-right padR10">
                            <span className={'chart_legend__circle'} style={{backgroundColor: '#93EB97'}}/>
                            <span className={'tiny_text white-text'}>Total tests taken</span>
                            <span className={'chart_legend__circle'} style={{backgroundColor: '#23AA29'}}/>
                            <span className={'tiny_text white-text'}>All tests complete</span>
                        </div>
                    </div>
                </div>
                <div className={'grid-x grid-padding-x'}>
                    <div className={'cell large-8 small-12'}>
                        {this.state.data ? <Chart data={this.state.data} /> : null}
                    </div>
                    <div className={'cell large-2 small-6 text-center'}>
                        <Progress progress={this.state.stats.total_tests_taken} color= '#93EB97' title='Total tests taken'
                                  description={'Description of all tests taken'} className={'mar-top-50'} />
                    </div>
                    <div className={'cell large-2 small-6 text-center'}>
                        <Progress progress={this.state.stats.all_tests_complete} color='#23AA29' title='All tests complete'
                                  description={'Users with career matches ready'} className={'mar-top-50'}/>
                    </div>
                </div>
                <div className="grid-x mar-top-45">
                    {[{code: 'interests', title: 'Career Interests'}, {code: 'personality', title: 'Work Personality'},
                        {code: 'motivators', title: 'Career Motivators'}, { code: 'abstract', title: "Abstract Reasoning"},
                        {code: "numerical", title: "Numerical Reasoning"}, {code: 'verbal', title: "Verbal Reasoning"}].
                    map((test) => {
                        return (
                            <div className="large-2 medium-4 small-6 cell text-center">
                                <Progress progress={this.state.stats[`${test.code}_finished`]}
                                          description={test.title} className={'circle-progress__container--mar-b-40'}/>
                            </div>
                        )
                    })}
                </div>

            </React.Fragment>
        )
    }
}
export default Result;